const p = (i) => ({
  ...i,
  h1: {
    ...i["Display2XL.Bold"]
  },
  h2: {
    ...i["DisplayXL.Bold"]
  },
  h3: {
    ...i["DisplayLg.Bold"]
  },
  h4: {
    ...i["DisplayMd.Bold"]
  },
  h5: {
    ...i["DisplaySm.Bold"]
  },
  h6: {
    ...i["DisplayXs.Bold"]
  },
  body1: {
    ...i["TextMd.Regular"]
  },
  body2: {
    ...i["TextSm.Regular"]
  },
  body1SemiBold: {
    ...i["TextMd.SemiBold"]
  },
  body2SemiBold: {
    ...i["TextSm.SemiBold"]
  },
  subtitle1: {
    ...i["DisplaySm.Regular"]
  },
  subtitle2: {
    ...i["DisplaySm.SemiBold"]
  },
  caption: {
    ...i["TextXs.Regular"],
    lineHeight: "1.25em",
    display: "inline-block"
  },
  button: {
    ...i["Deprecated.caption"]
  },
  overline: {
    ...i["TextSm.Medium"]
  }
});
export {
  p as compileTypographyWithBreakpoints
};
//# sourceMappingURL=compileTypographyWithBreakpoints.mjs.map
